// ©2024 Austin App House. All rights reserved.
import React from 'react';
import RowActions from '../../dashboard/RowActions';

const TableElement = ({
  label,
  value,
  isEditing,
  editName,
  onEditStart,
  onEditNameChange,
  onDelete,
}) => (
  <tr>
    <td>
      {isEditing ? (
        <div className="field_block">
          <input
            type="text"
            className="dashboard-input"
            placeholder="Name"
            name="editName"
            value={editName}
            onChange={(event) => onEditNameChange(event.target.value)}
          />
        </div>
      ) : (
        <span className="row-name">{label}</span>
      )}
    </td>
    <td className="actions-col">
      {!isEditing && (
        <RowActions
          alignEnd
          onEdit={() => onEditStart(value, label)}
          onDelete={(event) => {
            event.preventDefault();
            onDelete(value);
          }}
        />
      )}
    </td>
  </tr>
);

export default TableElement;
